export default __webpack_public_path__ + "static/media/v4.3e035e26.webp";